var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruckSteeringWheel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "39px",
    viewBox: "0 0 40 39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "524B9FE2-6AB2-4C3B-BE20-8B3315EAEF4E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Truck-Report---GMSA",
    transform: "translate(-48.000000, -414.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Conducci\\xF3n",
    transform: "translate(23.000000, 393.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Manejo",
    transform: "translate(26.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0514252,36.6911979 C29.5731118,36.6911979 38.102654,28.1616857 38.102654,17.6399991 C38.102654,11.968253 38.1368206,7.16979601 34.2038309,3.67972238 C30.8407103,0.695341726 23.9013657,0 19.0514252,0 C14.1619588,0 7.53797993,0.651872848 4.16497002,3.67972238 C0.279569708,7.16752936 0,12.007779 0,17.6399991 C0,28.1616857 8.52973864,36.6911979 19.0514252,36.6911979 Z",
    id: "Oval",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0515174,33.8687982 C28.01438,33.8687982 35.2802413,26.6029748 35.2802413,17.6401274 C35.2802413,12.8086781 35.3093459,8.93021209 31.9590421,5.95720989 C29.0941794,3.41497979 23.1829226,2.82265634 19.0515174,2.82265634 C14.8864422,2.82265634 9.24382854,3.37795104 6.37054162,5.95720989 C3.0607767,8.92828125 2.82262621,12.8423481 2.82262621,17.6401274 C2.82262621,26.6029748 10.0886548,33.8687982 19.0515174,33.8687982 Z",
    id: "Oval",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.82262621,13.1346435 C7.4612912,16.1310654 10.3449389,17.5219558 11.4735693,17.307315 C13.1665148,16.9853536 16.9584109,15.4923233 19.051327,15.4923233 C21.1442431,15.4923233 24.9034038,18 26.2655039,18 C27.1735706,18 30.1784831,16.6079941 35.2802413,13.8239822 L34.9440201,18.8688304 C29.7629439,19.7150334 26.524509,21.4222229 25.2287154,23.9903988 C23.9329218,26.5585747 23.285025,29.5358994 23.285025,32.9223729 C18.160742,34.1496002 15.4437681,34.1496002 15.1341035,32.9223729 C14.6696065,31.0815318 16.4002923,25.7982752 12.6893286,23.1465662 C10.2153528,21.3787602 6.78325655,19.6675431 2.39303997,18.0129149 L2.82262621,13.1346435 Z",
    id: "Path-3",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0514252,36.6911979 C29.5731118,36.6911979 38.102654,28.1616857 38.102654,17.6399991 C38.102654,11.968253 38.1368206,7.16979601 34.2038309,3.67972238 C30.8407103,0.695341726 23.9013657,0 19.0514252,0 C14.1619588,0 7.53797993,0.651872848 4.16497002,3.67972238 C0.279569708,7.16752936 -1.13686838e-13,12.007779 -1.13686838e-13,17.6399991 C-1.13686838e-13,28.1616857 8.52973864,36.6911979 19.0514252,36.6911979 Z",
    id: "Oval",
    stroke: "#45120F",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0515174,33.8687982 C28.01438,33.8687982 35.2802413,26.6029748 35.2802413,17.6401274 C35.2802413,12.8086781 35.3093459,8.93021209 31.9590421,5.95720989 C29.0941794,3.41497979 23.1829226,2.82265634 19.0515174,2.82265634 C14.8864422,2.82265634 9.24382854,3.37795104 6.37054162,5.95720989 C3.0607767,8.92828125 2.82262621,12.8423481 2.82262621,17.6401274 C2.82262621,26.6029748 10.0886548,33.8687982 19.0515174,33.8687982 Z",
    id: "Oval",
    stroke: "#45120F",
    strokeWidth: 1.41119992
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.19843905,13.1346435 C7.63024382,15.6677136 10.6105051,16.9342486 12.1392228,16.9342486 C14.4322994,16.9342486 15.6628314,15.4923233 19.051317,15.4923233 C22.4398026,15.4923233 24.1299412,17.307315 26.3158178,17.307315 C27.7730688,17.307315 30.6491363,16.1516244 34.9440201,13.8402434",
    id: "Path-9",
    stroke: "#45120F",
    strokeWidth: 1.41119992,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#45120F",
    strokeWidth: 1.41119992,
    fill: "#D8D8D8",
    cx: 19.0514252,
    cy: 21.1679989,
    r: 2.82239983
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.82262621,18.0129149 C7.17319744,20.0275444 9.72027322,21.2593158 10.4638536,21.7082289 C11.5792241,22.3815986 14.00219,24.5119013 14.5681467,27.1608925 C14.9454512,28.9268865 15.1341035,31.1628551 15.1341035,33.8687982",
    id: "Path-10",
    stroke: "#45120F",
    strokeWidth: 1.41119992
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.285025,18.0129149 C27.6355962,20.0275444 30.182672,21.2593158 30.9262523,21.7082289 C32.0416228,22.3815986 34.4645888,24.5119013 35.0305455,27.1608925 C35.40785,28.9268865 35.5965023,31.1628551 35.5965023,33.8687982",
    id: "Path-10",
    stroke: "#45120F",
    strokeWidth: 1.41119992,
    transform: "translate(29.440764, 25.940857) scale(-1, 1) translate(-29.440764, -25.940857) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckSteeringWheel);
export default __webpack_public_path__ + "static/media/truck-steering-wheel.749de603e355906936772bebc3af51a2.svg";
export { ForwardRef as ReactComponent };